export const GET_CONTACTS = 'GET_CONTACTS';
export const DELETE_CONTACT = 'DELETE_CONTACTS';
export const ADD_CONTACT = 'ADD_CONTACT';
export const GET_CONTACT = 'GET_CONTACT';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';



// WEBPACK FOOTER //
// ./src/actions/types.js